import React from 'react';
import { types as sdkTypes } from '../../util/sdkLoader';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * Renders the refunded-deposit amount after a dispute has been resolved.
 *
 * Post-dispute the transaction's line items contain at most a
 * `line-item/deposit-retained` (when retained > 0); no
 * `line-item/deposit-refunded` line is emitted, because adding it to
 * the customer side would ADD to their payin total and suppress the
 * Sharetribe refund delta (see docs/design/deposit-dispute-rearchitecture.md).
 *
 * The refunded amount therefore comes from metadata snapshotted by the
 * operator-transition endpoint at resolution time:
 *   transaction.attributes.metadata.disputeResolution
 *     .{ originalDepositSubunits, retainedSubunits, refundedSubunits }
 *
 * This component renders the refunded-amount line only when the
 * snapshot exists and refundedSubunits > 0.
 */
const LineItemDepositRefundedMaybe = props => {
  const { transaction, intl } = props;
  const resolution = transaction?.attributes?.metadata?.disputeResolution;
  const refundedSubunits = resolution?.refundedSubunits;
  if (typeof refundedSubunits !== 'number' || refundedSubunits <= 0) return null;

  const currency =
    transaction?.attributes?.payinTotal?.currency ||
    transaction?.attributes?.lineItems?.[0]?.lineTotal?.currency;
  if (!currency) return null;

  const label = intl.formatMessage({ id: 'OrderBreakdown.depositRefunded' });
  const formatted = formatMoney(intl, new Money(refundedSubunits, currency));

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>{label}</span>
      <span className={css.itemValue}>{formatted}</span>
    </div>
  );
};

export default LineItemDepositRefundedMaybe;
